import {vars} from "@/shared/lib";
import {useNavigate} from "@tanstack/react-router";
import {FallbackProps} from "react-error-boundary";
import Button from "../Button";
import Column from "../Column";
import Row from "../Row";
import Typography from "../Typography";
import {buttonsContainer, container} from "./index.css";

function GlobalErrorBoundary({error, resetErrorBoundary}: FallbackProps) {
	const e = error as Error;
	const navigate = useNavigate();
	console.error("[GlobalErrorBoundary]", e);

	return (
		<Column fullWidth className={container}>
			<Typography size={vars.size[24]}>{"문제가 발생했습니다"}</Typography>
			<Typography size={vars.size[16]}>{e.message}</Typography>
			{/* <Typography size={vars.size[16]}>{e.stack}</Typography> */}

			<Row className={buttonsContainer}>
				<Button
					size={"medium"}
					onClick={() => {
						resetErrorBoundary();
						navigate({
							to: "/",
							replace: true
						});
					}}
				>
					{"새로고침"}
				</Button>
			</Row>
		</Column>
	);
}

export default GlobalErrorBoundary;
